export enum UserAddressesPathsEnum {
  LIST_USER_ADDRESSES = "/user-addresses",
  CREATE_USER_ADDRESSES = "/user-addresses/:id(\\d+)?/:mode(edit|create)",
}
